import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DEMO_ACCOUNTS = [
  { email: 'cole@gmail.com',      role: 'Admin / CHRO', color: '#1e3a8a' },
  { email: 'khoi.tran@abc.com',   role: 'HR Manager',   color: '#0f766e' },
  { email: 'duc.pham@abc.com',    role: 'IT Manager',   color: '#7c3aed' },
  { email: 'trang.ngo@abc.com',   role: 'Employee',     color: '#b45309' },
];

const FEATURES = [
  { icon: '👥', text: 'Core HR & Sơ đồ tổ chức' },
  { icon: '⏱️', text: 'Chấm công đa phương thức' },
  { icon: '📅', text: 'Nghỉ phép & Phê duyệt workflow' },
  { icon: '💰', text: 'Tính lương tự động (BHXH / TNCN)' },
  { icon: '📈', text: 'Báo cáo tuần & tháng' },
  { icon: '🎯', text: 'Quản lý chiến dịch & nhiệm vụ' },
];

export default function LoginPage() {
  const [email, setEmail]       = useState('cole@gmail.com');
  const [password, setPassword] = useState('cole@2026');
  const [showPw, setShowPw]     = useState(false);
  const [error, setError]       = useState('');
  const { login, loading }      = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Email hoặc mật khẩu không đúng');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f1f5c 0%, #1e3a8a 50%, #0c5a87 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
      fontFamily: "'Be Vietnam Pro', Inter, sans-serif",
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Decorative circles */}
      <div style={{ position: 'absolute', width: 400, height: 400, borderRadius: '50%', background: 'rgba(255,255,255,0.03)', top: -120, left: -100, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', width: 300, height: 300, borderRadius: '50%', background: 'rgba(255,255,255,0.04)', bottom: -80, right: -60, pointerEvents: 'none' }} />

      <div style={{ width: '100%', maxWidth: 940, display: 'flex', gap: 32, alignItems: 'center', position: 'relative', zIndex: 1 }}>

        {/* ── LEFT: Branding ── */}
        <div style={{ flex: 1, color: '#fff', padding: '32px 24px', display: 'flex', flexDirection: 'column' }}>

          {/* Logo */}
          <div style={{ marginBottom: 28 }}>
            <img
              src="https://cole.vn/client_fe/v2/images/logo-white.png"
              alt="Cole"
              style={{ height: 44, objectFit: 'contain' }}
            />
          </div>

          {/* Title */}
          <div style={{ marginBottom: 10 }}>
            <h1 style={{ fontSize: 30, fontWeight: 800, margin: '0 0 6px', lineHeight: 1.2, letterSpacing: '-0.5px' }}>
              Hệ thống Quản lý<br />Nhân sự
            </h1>
            <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', borderRadius: 20, padding: '3px 12px', fontSize: 12, fontWeight: 600, letterSpacing: '0.5px', marginTop: 6 }}>
              COLE HRM · v2.0
            </div>
          </div>

          <p style={{ fontSize: 14, opacity: 0.75, lineHeight: 1.7, margin: '12px 0 28px', maxWidth: 340 }}>
            Nền tảng quản lý nhân sự toàn diện — từ tuyển dụng đến tính lương, phù hợp cho doanh nghiệp Việt Nam.
          </p>

          {/* Feature list */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {FEATURES.map(f => (
              <div key={f.text} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{
                  width: 28, height: 28, borderRadius: 8, flexShrink: 0,
                  background: 'rgba(255,255,255,0.12)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14,
                }}>
                  {f.icon}
                </span>
                <span style={{ fontSize: 13, opacity: 0.88 }}>{f.text}</span>
              </div>
            ))}
          </div>

          {/* Cole tagline */}
          <div style={{ marginTop: 'auto', paddingTop: 32, opacity: 0.5, fontSize: 11 }}>
            Learn Remotely · Work Globally · Digital Skills For Everyone
          </div>
        </div>

        {/* ── RIGHT: Login card ── */}
        <div style={{
          width: 420, flexShrink: 0,
          background: '#fff', borderRadius: 20,
          padding: '36px 36px 28px',
          boxShadow: '0 24px 80px rgba(0,0,0,0.35)',
        }}>
          {/* Card header */}
          <div style={{ textAlign: 'center', marginBottom: 28 }}>
            <img
              src="https://cole.vn/client_fe/v2/images/logo-cole-final.png"
              alt="Cole HRM"
              style={{ height: 38, objectFit: 'contain', marginBottom: 14 }}
            />
            <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1e293b', margin: '0 0 4px' }}>
              Đăng nhập hệ thống
            </h2>
            <p style={{ color: '#94a3b8', fontSize: 13, margin: 0 }}>Quản lý nhân sự Cole</p>
          </div>

          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca',
              borderRadius: 8, padding: '10px 14px', color: '#dc2626',
              fontSize: 13, marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <span>⚠️</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                Email
              </label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)} required
                placeholder="example@cole.vn"
                style={{
                  width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0',
                  borderRadius: 9, fontSize: 14, boxSizing: 'border-box',
                  outline: 'none', color: '#1e293b', transition: 'border-color 0.15s',
                  fontFamily: 'inherit',
                }}
                onFocus={e => e.target.style.borderColor = '#1e3a8a'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            {/* Password */}
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                Mật khẩu
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPw ? 'text' : 'password'}
                  value={password} onChange={e => setPassword(e.target.value)} required
                  placeholder="••••••••"
                  style={{
                    width: '100%', padding: '11px 42px 11px 14px', border: '1.5px solid #e2e8f0',
                    borderRadius: 9, fontSize: 14, boxSizing: 'border-box',
                    outline: 'none', color: '#1e293b', transition: 'border-color 0.15s',
                    fontFamily: 'inherit',
                  }}
                  onFocus={e => e.target.style.borderColor = '#1e3a8a'}
                  onBlur={e => e.target.style.borderColor = '#e2e8f0'}
                />
                <button type="button" onClick={() => setShowPw(p => !p)} style={{
                  position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#94a3b8', padding: 0, lineHeight: 1,
                }}>
                  {showPw ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <button
              type="submit" disabled={loading}
              style={{
                width: '100%', padding: '12px',
                background: loading ? '#93c5fd' : 'linear-gradient(135deg, #1e3a8a, #0891b2)',
                color: '#fff', border: 'none', borderRadius: 9,
                fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
                letterSpacing: '0.3px', transition: 'opacity 0.15s',
                boxShadow: loading ? 'none' : '0 4px 14px rgba(30,58,138,0.35)',
              }}
            >
              {loading ? '⏳ Đang đăng nhập...' : 'Đăng nhập →'}
            </button>
          </form>

          {/* Demo accounts */}
          <div style={{ marginTop: 24, borderTop: '1px solid #f1f5f9', paddingTop: 18 }}>
            <p style={{ fontSize: 11, color: '#94a3b8', marginBottom: 10, textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Tài khoản demo — mật khẩu: cole@2026
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 7 }}>
              {DEMO_ACCOUNTS.map(acc => (
                <button
                  key={acc.email}
                  onClick={() => { setEmail(acc.email); setPassword('cole@2026'); setError(''); }}
                  style={{
                    padding: '8px 10px', background: `${acc.color}0e`,
                    border: `1px solid ${acc.color}28`, borderRadius: 7,
                    cursor: 'pointer', textAlign: 'left', transition: 'background 0.12s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = `${acc.color}1a`}
                  onMouseLeave={e => e.currentTarget.style.background = `${acc.color}0e`}
                >
                  <div style={{ fontSize: 11, fontWeight: 700, color: acc.color }}>{acc.role}</div>
                  <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 1 }}>{acc.email.split('@')[0]}</div>
                </button>
              ))}
            </div>
          </div>

          <p style={{ textAlign: 'center', fontSize: 11, color: '#cbd5e1', marginTop: 16, marginBottom: 0 }}>
            © 2025 Cole Edtech · HRM System
          </p>
        </div>
      </div>
    </div>
  );
}
